module.exports = __webpack_public_path__ + "static/media/ball-triangle.94c84966.svg";